import React from 'react';
import { useQuery } from '@tanstack/react-query';
import PlatformLayout from '../../components/layout/PlatformLayout';
import { platformAxios } from '../../context/PlatformAuthContext';

/**
 * Renders an internal HTML doc (Product Roadmap / Bugs & Tweaks tracker)
 * inside the platform portal. The docs are full standalone HTML pages with
 * their own styling, so they render in a sandboxed iframe via srcDoc — no
 * style bleed either way. Content is fetched with platform auth and always
 * reflects the latest deploy.
 */
export default function PlatformDoc({ doc, title }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['platform-doc', doc],
    queryFn: () => platformAxios.get(`/docs/${doc}`).then(r => r.data),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <PlatformLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 90px)' }}>
        {isLoading && <p style={{ padding: 24 }}>Loading {title}…</p>}
        {error && (
          <p style={{ padding: 24 }}>
            Couldn't load {title} — it may not be included in this deployment yet.
          </p>
        )}
        {data?.html && (
          /* Fully sandboxed (empty sandbox): the docs are script-free by
             design — CSS-only filtering — so nothing needs allowing. Prod
             CSP blocks inline scripts in srcdoc iframes anyway. */
          <iframe
            title={title}
            srcDoc={data.html}
            sandbox=""
            style={{ flex: 1, width: '100%', border: 'none', borderRadius: 12, background: '#F4EFE6' }}
          />
        )}
      </div>
    </PlatformLayout>
  );
}
